import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { MobileNavLink } from '@/components/frontend/atoms/navigation/MobileNavLink'

interface NavItem {
  label: string
  href: string
}

interface MobileNavMenuProps {
  items: NavItem[]
  currentPath?: string
  onNavigate?: () => void
}

export const MobileNavMenu: React.FC<MobileNavMenuProps> = ({
  items,
  currentPath,
  onNavigate,
}) => (
  <Stack gap="6" align="center">
    {items.map((item) => (
      <MobileNavLink
        key={item.href}
        href={item.href}
        active={currentPath === item.href}
        onClick={onNavigate}
      >
        {item.label}
      </MobileNavLink>
    ))}
  </Stack>
)
